export class FeatureOptionCharacteristicsFactory {
    static create(featureOptionCharacteristics: IFeatureOptionCharacteristics): IContentAPIFeatureOptionCharacteristics {
        return new FeatureOptionCharacteristics(featureOptionCharacteristics).serialize();
    }
}

export class FeatureOptionCharacteristics {
    protected _positionVertical?: CharacteristicPositionVertical;
    protected _positionHorizontal?: CharacteristicPositionHorizontal;
    protected _orientation?: CharacteristicOrientation;
    protected _side?: CharacteristicSide;
    protected _toggle?: CharacteristicToggle;

    // Store any additional dynamic characteristics beyond the predefined ones
    protected _additionalCharacteristics: Record<string, string | boolean | number | undefined> = {};

    constructor(featureOptionCharacteristics: IFeatureOptionCharacteristics) {
        this._positionVertical = featureOptionCharacteristics.positionVertical;
        this._positionHorizontal = featureOptionCharacteristics.positionHorizontal;
        this._orientation = featureOptionCharacteristics.orientation;
        this._side = featureOptionCharacteristics.side;
        this._toggle = featureOptionCharacteristics.toggle;

        // Capture any additional characteristics beyond the known ones
        const knownKeys = new Set(['positionVertical', 'positionHorizontal', 'orientation', 'side', 'toggle']);
        for (const [key, value] of Object.entries(featureOptionCharacteristics)) {
            if (!knownKeys.has(key)) {
                this._additionalCharacteristics[key] = value;
            }
        }
    }

    serialize(): IContentAPIFeatureOptionCharacteristics {
        const featureOptionCharacteristics: IContentAPIFeatureOptionCharacteristics = {
            ...this._additionalCharacteristics  // Include dynamic characteristics first
        };

        // Known properties override any dynamic ones with the same name
        if (this._positionVertical !== undefined) {
            featureOptionCharacteristics.positionVertical = this._positionVertical;
        }

        if (this._positionHorizontal !== undefined) {
            featureOptionCharacteristics.positionHorizontal = this._positionHorizontal;
        }

        if (this._orientation !== undefined) {
            featureOptionCharacteristics.orientation = this._orientation;
        }

        if (this._side !== undefined) {
            featureOptionCharacteristics.side = this._side;
        }

        if (this._toggle !== undefined) {
            featureOptionCharacteristics.toggle = this._toggle;
        }

        return featureOptionCharacteristics;
    }
}

export interface IContentAPIFeatureOptionCharacteristics {
    positionVertical?: CharacteristicPositionVertical;
    positionHorizontal?: CharacteristicPositionHorizontal;
    orientation?: CharacteristicOrientation;
    side?: CharacteristicSide;
    toggle?: CharacteristicToggle;

    // Support dynamic characteristics beyond the predefined ones
    [key: string]: string | boolean | number | undefined;
}